import { computed, signal } from "@preact/signals-react"

export const multimediaCarouselInitPos = signal(0)
export const multimediaCarouselImages = signal([])
export const multimediaCarouselVideos = signal([])

export const multimediaCarouselImagesIsOpen = computed(() => multimediaCarouselImages.value.length > 0)
export const multimediaCarouselVideosIsOpen = computed(() => multimediaCarouselVideos.value.length > 0)